/* eslint-disable max-len */
import React, { Component } from 'react';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import Icon from '@lyearn-team/frontend-components/dist/Icon';
import url from 'helper/url';
import { getQueryStringVal } from 'helper/QueryString';

import DarkBoxInput from '@lyearn-team/frontend-components/dist/Input/DarkBoxInput';
import DarkButton from '@lyearn-team/frontend-components/dist/Button/DarkButton';
import {
  Column,
  FixWidthColumn,
  CompanyPageWrapper,
  SeperatorRow,
  ContactLyearnText,
  GlobalErrorWrapper,
  inputClass,
  buttonClass,
  CloseButton,
  passwordWrapperClass,
  TroubleLogingInButton
} from './styles';
import DarkLoginTypes from '../Components/DarkLoginTypes';
import ForgotPassword from '../ForgotPassword';
import { LoginContentHeading, LoginNormalText } from '../styles';
import DarkTroubleLogin from '../DarkTroubleLogin';

export default class DarkCompanyLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForgotPasswordPopup: false,
      showToubleLoginPopup: false,
      userName: '',
      userPassword: '',
      loading: false,
      globalError: 'constant',
      forceEnableEmailLogin: false
    };
    this.companyInfo = props.companyInfo;
    try {
      const userName =
        getQueryStringVal('un') && decodeURIComponent(window.atob(getQueryStringVal('un')));
      const password =
        getQueryStringVal('pw') && decodeURIComponent(window.atob(getQueryStringVal('pw')));
      const reason = getQueryStringVal('r');
      switch (reason) {
        case 'USER_NOT_EXISTS':
          this.state.globalError = "We couldn't find user for this username.";
          break;
        case 'TOKEN_EXPIRED':
          this.state.globalError = 'Please try to login again.';
          break;
        case 'INVALID_SAML_RESPONSE':
          this.state.globalError = 'Invalid SAML configuration, please contact your administrator';
          break;
        default:
          break;
      }
      if (userName && password) {
        this.state.userName = userName;
        this.state.userPassword = password;
      }
    } catch (e) {
      console.error('unable to set username/password from url', e);
      window.bugsnagClient &&
        window.bugsnagClient.notify(e, {
          type: 'custom_error_track',
          message: 'unable to parse username/password from url',
          error: e,
          time: new Date().toISOString()
        });
    }

    if (getQueryStringVal('manualEmailLogin')) {
      this.state.forceEnableEmailLogin = true;
    }
  }

  componentDidMount() {
    window.hj && window.hj('tagRecording', ['login_page']);
  }

  onUserNameChange = e => {
    const { globalError, userName } = this.state;
    if (globalError && userName) {
      this.setState({ globalError: 'constant' });
    }
    this.setState({ userName: e.target.value.trim() });
  };

  onUserPasswordChange = e => {
    const { globalError, userPassword } = this.state;
    if (globalError && userPassword) {
      this.setState({ globalError: 'constant' });
    }
    this.setState({ userPassword: e.target.value });
  };

  togglePopup = () => {
    this.setState({ showForgotPasswordPopup: !this.state.showForgotPasswordPopup });

    if (!this.state.showForgotPasswordPopup && window.bowser.mobile) {
      document.getElementById('lyearnlogo').style.display = 'none';
    } else {
      document.getElementById('lyearnlogo').style.display = 'block';
    }
  };

  toggleToubleLoginPopup = () => {
    this.setState({
      showToubleLoginPopup: !this.state.showToubleLoginPopup
    });
  };

  validateInputs = () => {
    const { userName, userPassword } = this.state;
    if (!userName || !userPassword) {
      return false;
    }
    return true;
  };

  loginUser = async () => {
    if (!this.validateInputs()) return;
    const { userName, userPassword } = this.state;
    const redirectURL = window.location.host + '/#/login-redirect';

    const redirectHost = encodeURIComponent(redirectURL);
    const subdomain = this.props.companyInfo.subDomain;
    const endpoint = `/testglogin?redirectHost=${redirectHost}&subdomain=${subdomain}&device=web&loginMode=cognito`;
    const bUrl = `${url.awsEndpoint}${endpoint}`;
    this.setState({ loading: true });

    try {
      const res = await fetch(bUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userName: userName.toLowerCase(),
          password: userPassword
        })
      });

      const response = await res.json();
      this.setState({ loading: false });
      if (response.errorMessage) {
        console.log('errorMessage is', response.errorMessage);
        throw new Error(response.errorMessage);
      }
      const location = response.location;
      this.setState({ loading: false });
      // debugger;
      window.location.href = location;
    } catch (error) {
      this.setState({ loading: false });
      const errorMessage = error.message;
      let errorObject = {};
      try {
        errorObject = JSON.parse(JSON.parse(errorMessage).error);
        if (!errorObject.code && errorObject.error) {
          errorObject = errorObject.error;
        }
      } catch (err) {
        console.log('err', err);
      }
      switch (errorObject.code) {
        /* This is removed in order to show same message */
        /* this.setState({ globalError: "We couldn't find user for this username." });
          break; */
        case 'UserNotFoundException':
        case 'NotAuthorizedException':
          this.setState({ globalError: 'Incorrect username or password.' });
          break;
        case 'NEW_PASSWORD_REQUIRED': {
          localStorage.setItem(
            'set_password_data',
            JSON.stringify({
              userName,
              val: window.btoa(userPassword)
            })
          );
          window.location.href = `/#/set-new-password`;
          break;
        }
        case 'TOKEN_EXPIRED':
          window.location.href = '/#/login?r=TOKEN_EXPIRED';
          break;
        default:
          this.setState({
            globalError: 'Something went wrong! Please try to login after some time.'
          });
      }
    }
  };

  loginFormOnSubmit = event => {
    event.preventDefault();
    this.loginUser();
  };

  renderActivityIndicator = (width, height, inButton) => {
    if (inButton) {
      return (
        <ActivityIndicator
          width={width}
          height={height}
          style={{ marginRight: '8px', fill: '#fff' }}
          svgColor="#fff"
        />
      );
    }
    return <ActivityIndicator width={width} height={height} />;
  };

  renderLogins = loginTypes => (
    <DarkLoginTypes
      ldClient={this.props.ldClient}
      loginTypes={loginTypes}
      companyInfo={this.props.companyInfo}
    />
  );

  renderSignInWrapper = () => {
    if (
      this.props.companyInfo.loginTypes.indexOf('EMAIL_LOGIN') < 0 &&
      !this.state.forceEnableEmailLogin
    ) {
      return null;
    }
    const { userName, loading, userPassword } = this.state;
    let icon = '';
    if (loading) {
      icon = this.renderActivityIndicator(12, 12, true);
    }
    return (
      <form className={Column} onSubmit={this.loginFormOnSubmit}>
        <DarkBoxInput
          placeholder="User name"
          type="email"
          value={userName}
          required={true}
          onChange={this.onUserNameChange}
          className={inputClass}
        />

        <DarkBoxInput.Password
          placeholder="Password"
          value={userPassword}
          required={true}
          onChange={this.onUserPasswordChange}
          className={inputClass}
          passwordWrapperClassName={passwordWrapperClass}
        />

        <DarkButton.TextButton
          type="button"
          className={TroubleLogingInButton}
          onClick={this.toggleToubleLoginPopup}
        >
          Trouble logging in?
        </DarkButton.TextButton>
        <DarkButton
          className={buttonClass}
          type="submit"
          disabled={loading || !userName || !userPassword}
        >
          {icon}
          {loading ? 'Logging in' : 'Login'}
        </DarkButton>
      </form>
    );
  };

  render() {
    if (!this.props.companyInfo) {
      return null;
    }

    const { companyInfo, state } = this;
    const { subDomain: companySubDomain, name: companyName } = this.props.companyInfo;
    const { showForgotPasswordPopup, globalError, showToubleLoginPopup } = state;
    const showSeperator = (() => {
      if (
        (companyInfo.loginTypes.indexOf('EMAIL_LOGIN') > -1 && companyInfo.loginTypes.length > 1) ||
        (this.state.forceEnableEmailLogin && companyInfo.loginTypes.length > 0)
      ) {
        return true;
      }
      return false;
    })();
    if (showForgotPasswordPopup) {
      return (
        <CompanyPageWrapper>
          <CloseButton onClick={this.togglePopup}>
            <Icon type="close" iconColor="black3" style={{ width: '16px', height: '16px' }} />
          </CloseButton>
          <ForgotPassword companySubDomain={companySubDomain} />
        </CompanyPageWrapper>
      );
    }

    if (showToubleLoginPopup) {
      return (
        <CompanyPageWrapper className="troubleLoginPageWrapper">
          <DarkTroubleLogin
            companySubDomain={companySubDomain}
            backToSignIn={() => {
              this.setState({
                showToubleLoginPopup: false
              });
            }}
          />
        </CompanyPageWrapper>
      );
    }

    return (
      <CompanyPageWrapper className="loginPageWrapper">
        <LoginContentHeading style={{ textAlign: 'center' }}>
          Sign in to <strong>{companyName}</strong>
        </LoginContentHeading>
        <LoginNormalText>{companySubDomain}.lyearn.com</LoginNormalText>
        <FixWidthColumn>
          {this.renderLogins(companyInfo.loginTypes)}
          {showSeperator && (
            <SeperatorRow>
              <LoginNormalText>or</LoginNormalText>
            </SeperatorRow>
          )}
          {this.renderSignInWrapper()}
          <GlobalErrorWrapper
            style={{ visibility: globalError === 'constant' ? 'hidden' : undefined }}
          >
            {globalError}
          </GlobalErrorWrapper>
        </FixWidthColumn>
        <ContactLyearnText>
          Not able to sign in? Please reach out to us at{' '}
          <a href="mailto:support@lyearn.com" style={{ 'text-decoration': 'none' }}>
            support@lyearn.com
          </a>
        </ContactLyearnText>
        {/* <PrivacyPolicyLink>
          <a href="#/privacy-policy">Privacy Policy</a>
        </PrivacyPolicyLink> */}
      </CompanyPageWrapper>
    );
  }
}
